<template>
    <div>
        <van-nav-bar
                title="草莓雨奖品"
                left-text="返回"
                right-text=""
                left-arrow
                @click-left="onNavClickLeft"
        />
        <van-notice-bar
                left-icon="volume-o"
                text="请在园区现场收银时展示可用券给工作人员。"
        />

        <van-coupon-list
                :coupons="list"
                :show-exchange-bar="false"
                :show-close-button="false"
        />
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: "MyRewards",
        data(){
            return{
                list:[],
                loading:false,
            }
        },
        methods:{
            ...mapActions([
                'GetMyRewardList',
            ]),
            load_list(){
                this.loading=true;
                let p={
                    uid:this.$store.getters.getLoginUser.id,
                };
                this.GetMyRewardList(p).then(res=>{
                    this.loading=false;
                    this.list=res;
                });
            },
            onNavClickLeft(){
                this.$router.go(-1);
            },
        },
        mounted() {
            document.body.style.backgroundColor='#F3F4F5';  //设置整页背景色
            this.load_list();
        }
    }
</script>

<style scoped>

</style>
